const slider = {

    elements: {},

    cacheDom() 
    {
        this.elements.$slideshow = jQuery('.js-slider');
    },

    bind()
    {
        this.elements.$slideshow.on('init', () => {
            
        });


        this.elements.$slideshow.slick({
            dots: true,
            fade: true,
            infinite: true,
            slide: '.slide',
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            nextArrow: '<button type="button" class="slider__arrow slider__arrow--next"></button>',
            prevArrow: '<button type="button" class="slider__arrow slider__arrow--prev"></button>',
            customPaging : function(slider, i) {
                return '<button type="button" class="slider__dot"></button>';
            },
        });
    },

    init() {
        this.cacheDom();

        if( this.elements.$slideshow.length )
        {
            this.bind();
        }
    }
}

export default slider;